import { tryCatchHelper } from '../../../../helpers';
import {
  ACTIVO_ENT_HORARIO_CLASES,
  ALL_ENT_HORARIO_CLASES,
  LOADING_ALL_ENT_HORARIO_CLASES,
} from './EntHorarioClasesReducer';
import {
  allEntHorarioClasesService,
  deleteEntHorarioClasesService,
  oneEntHorarioClasesService,
  saveEntHorarioClasesService,
} from './EntHorarioClasesService';

export const allEntHorarioClasesAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_ENT_HORARIO_CLASES, payload: true });
    const res = await allEntHorarioClasesService(params);
    if (res.status === 200) {
      dispatch({ type: ALL_ENT_HORARIO_CLASES, payload: res.data });
      dispatch({ type: LOADING_ALL_ENT_HORARIO_CLASES, payload: false });
      return res.data;
    }
    dispatch({ type: LOADING_ALL_ENT_HORARIO_CLASES, payload: false });
    return null;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const saveEntHorarioClasesAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveEntHorarioClasesService(id, data);
    notify(res.data.message);
    await allEntHorarioClasesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoEntHorarioClasesAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_ENT_HORARIO_CLASES, payload: data });
};

export const oneEntHorarioClasesAction = async (dispatch, id) => {
  try {
    const res = await oneEntHorarioClasesService(id);
    await setActivoEntHorarioClasesAction(dispatch, res.data.data);
    return res.data.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteEntHorarioClasesAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteEntHorarioClasesService(id);
    notify(res.data.message);
    await setActivoEntHorarioClasesAction(dispatch, null);
    await allEntHorarioClasesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
